import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=98f5336c"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f5336c')) {
      api.createRecord('98f5336c', component.options)
    } else {
      api.reload('98f5336c', component.options)
    }
    module.hot.accept("./ItemView.vue?vue&type=template&id=98f5336c", function () {
      api.rerender('98f5336c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemView.vue"
export default component.exports